"use client";

import * as React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const cleaningBenefits = [];
export default function RealEstateCleaning() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: footerRef,
    isVisible: isFooterVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section data-section-id="176152" id="imageandtextblock" className="bg-background py-[120px] overflow-hidden !h-[200px]">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <span className="font-sans tracking-[0.3em] uppercase block !text-[hsl(172,66%,50%)] !font-extrabold !text-3xl ![margin:-90px_0px_16px_50px]">THE NEW MAVERICKS EDGE</span>
          <h2 className="font-sans font-bold mb-6 leading-tight !text-[hsl(0,0%,100%)] !text-4xl !w-[850px]">Evolving Leaders to Create Extraordinary Results</h2>
          <p className="font-sans text-lg leading-relaxed !text-[hsl(0,0%,100%)] !w-[825px]">Unlocking top Founders, CEOs &amp; executives full leadership potential through the highest leadership consciousness development for sustained peak state functioning &amp; evolutionary transformational impact from the inside out, as these clients share below:<br />&nbsp;<br />In their own words, this is what the clients below have experienced:</p>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16 md:mt-20">
          {cleaningBenefits.map((benefit, i) => <div key={i} data-index={i} className={`transition-all duration-700 ease-out delay-[${i * 150}ms] ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <Card className="text-card-foreground flex flex-col gap-6 py-6 h-full rounded-none border-none bg-slate-50/10 backdrop-blur-sm shadow-medium transition-shadow duration-300 ![margin:-40px_0px_0px_0px] hover:shadow-strong">
                <CardHeader className="pb-4 pt-8 px-8">
                  <CardTitle className="font-sans text-2xl font-bold leading-snug !text-[hsl(0,0%,100%)]">
                    {benefit.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="px-8 pb-8 ![margin:-30px_0px_0px_0px]">
                  {i === 0 && <iframe src="https://www.youtube.com/embed/Z3hy1jsGqlc" className="w-full mb-6 rounded-lg aspect-video shadow-medium" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen />}
                  <p className="font-sans leading-relaxed text-base !text-[hsl(0,0%,100%)]">
                    {benefit.description}
                  </p>
                </CardContent>
              </Card>
            </div>)}
        </div>

        <div ref={footerRef} className={`mt-16 md:mt-20 text-center transition-all duration-1000 ease-out delay-300 ${isFooterVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          
        </div>
      </div>
    </section>;
}